import { useMemo } from 'react'
import { useIntl } from 'react-intl'

export const FlightChangeDatesPageStep = {
  SELECT_FLIGHTS_TO_CHANGE: 'SELECT_FLIGHTS_TO_CHANGE',
  SELECT_DATES_TO_CHANGE: 'SELECT_DATES_TO_CHANGE',
  SELECT_NEW_FLIGHTS: 'SELECT_NEW_FLIGHTS',
  INSURANCE_SELECT_DATES: 'INSURANCE_SELECT_DATES',
  REVIEW_AND_PAY: 'REVIEW_AND_PAY',
} as const

export type FlightChangeDatesPageStepDefinition = typeof FlightChangeDatesPageStep[keyof typeof FlightChangeDatesPageStep]

export function useFlightsCheckoutStepLabels(): Record<string, string> {
  const intl = useIntl()
  return useMemo(() => ({
    'Change Flights': intl.formatMessage({
      id: 'mCUiaCXjdN',
      defaultMessage: 'Change Flights',
      description: 'Flights checkout step label for selecting flights to change',
    }),
    'Select dates': intl.formatMessage({
      id: 'AJMfbR0al/',
      defaultMessage: 'Select dates',
      description: 'Flights checkout step label for selecting new dates',
    }),
    'New Flights': intl.formatMessage({
      id: 'A1OTmboPUI',
      defaultMessage: 'New Flights',
      description: 'Flights checkout step label for selecting new flights',
    }),
    Insurance: intl.formatMessage({
      id: '5/LkrB92C3',
      defaultMessage: 'Insurance',
      description: 'Flights checkout step label for insurance selection',
    }),
    'Review & Pay': intl.formatMessage({
      id: 'ebDASdTG1L',
      defaultMessage: 'Review & Pay',
      description: 'Flights checkout step label for review and payment',
    }),
  }), [intl])
}

export const FLIGHTS_CHECKOUT_HEADER_STEPS: Array<App.Checkout.CheckoutStep> = [
  {
    label: 'Change Flights',
    key: FlightChangeDatesPageStep.SELECT_FLIGHTS_TO_CHANGE,
    subSteps: [],
    isRoute: false,
  },
  {
    label: 'Select dates',
    key: FlightChangeDatesPageStep.SELECT_DATES_TO_CHANGE,
    subSteps: [],
    isRoute: true,
  },
  {
    label: 'New Flights',
    key: FlightChangeDatesPageStep.SELECT_NEW_FLIGHTS,
    isRoute: true,
    subSteps: [],
  },
  {
    label: 'Insurance',
    key: FlightChangeDatesPageStep.INSURANCE_SELECT_DATES,
    isRoute: true,
    subSteps: [],
  },
  {
    label: 'Review & Pay',
    key: FlightChangeDatesPageStep.REVIEW_AND_PAY,
    isRoute: true,
    subSteps: [],
  },
]
